import React from 'react';
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const DynamicImage = ( props ) => {
    let src = getImage(props.src);
    const altText = props.alt || ""; // Use the provided alt or an empty string if not provided

    return (
        <GatsbyImage image={src} alt={altText} loading="lazy" placeholder="none" />
    );
};

export default DynamicImage;
